import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentModalComponent } from './document-modal.component';
import { OpsFileAttachSpinnerComponent } from '@ops/storybook';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, OpsFileAttachSpinnerComponent, TranslateModule],
  exports: [DocumentModalComponent],
  declarations: [DocumentModalComponent],
})
export class DocumentModalModule {}
